// API base URL. Vite injects VITE_API_URL at build time; VITE_API_BASE is
// accepted as an alias (pos-web uses that name — accepting both prevents a
// wrong-var build from silently falling back to localhost).
//
// The fallback is mode-aware ON PURPOSE: a *production* build with no override
// resolves to the real API, not localhost, so a plain `vite build` + deploy can
// never ship a bundle that talks to localhost (which silently breaks login on
// staging/prod). Dev keeps the local docker-compose default so no .env is
// needed to run locally. Override either default with VITE_API_URL at build.
const PROD_API_FALLBACK = 'https://api.uat.erp-pro.net'; // TODO(prod-cutover): real prod host
const DEV_API_FALLBACK = 'http://localhost:5099';
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (import.meta.env.PROD ? PROD_API_FALLBACK : DEV_API_FALLBACK);

// In development we pre-fill the tenant slug field with this value so devs
// don't keep typing "acme". Production runs on a tenant subdomain — the
// field is hidden there and the slug is implied by the host.
export const DEFAULT_TENANT_SLUG: string =
  (import.meta.env.VITE_DEFAULT_TENANT as string | undefined) ?? 'acme';

export const IS_DEV = import.meta.env.DEV;

// Whether the login page renders the tenant slug field. Defaults to
// true everywhere except a true production build on a tenant subdomain
// (e.g. acme.wheels.delivery) where the slug is inferable from the
// host. Set VITE_SHOW_TENANT_FIELD=false at build time to hide it.
export const SHOW_TENANT_FIELD: boolean =
  (import.meta.env.VITE_SHOW_TENANT_FIELD as string | undefined) !== 'false';
